import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import axios from "../../utils/axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import AdminNav from "./AdminNav";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const Users = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const navigate = useNavigate();
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const getAllUsersData = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/auth/m-users`
      );
      setLoading(false);
      if (data?.success) {
        const sortedData = data.users.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setUsers(sortedData);
        setFilteredUsers(sortedData);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getAllUsersData();
  }, []);

  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();
    setFilteredUsers(
      term
        ? users.filter(
            (user) =>
              user.username?.toLowerCase().includes(term) ||
              user.name?.toLowerCase().includes(term) ||
              user.email?.toLowerCase().includes(term)
          )
        : users
    );
  }, [searchTerm, users]);

  const getStatusBadge = (status) => {
    return status === 0 ? (
      <span className="badge bg-success">Active</span>
    ) : (
      <span className="badge bg-danger">Blocked</span>
    );
  };

  const getKycBadge = (kycstatus) => {
    switch (kycstatus) {
      case 0:
        return <span className="badge bg-secondary">Not Submitted</span>;
      case 1:
        return <span className="badge bg-warning text-dark">Pending</span>;
      case 2:
        return <span className="badge bg-success">Approved</span>;
      case 3:
        return <span className="badge bg-danger">Rejected</span>;
      default:
        return <span className="badge bg-light text-dark">Unknown</span>;
    }
  };
  const checkStatusAndNavigate = async (user) => {
    if (user.kycstatus === 2) {
      navigate(`/dashboard/admin/user-details/${user._id}`);
    } else {
      Swal.fire({
        title: "KYC Not Completed",
        text: `${user.name} has not completed KYC.  `,
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };
  const handleStatusClick = async (user) => {
    const action = user.status === 0 ? "lock" : "unlock";
    const confirmText =
      user.status === 0
        ? `Are you sure? You are going to lock ${user.name}`
        : `Are you sure? You are going to unlock ${user.name}`;

    const result = await Swal.fire({
      title: "Confirm Action",
      text: confirmText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: user.status === 0 ? "#d33" : "#3085d6",
      cancelButtonColor: "#6c757d",
      confirmButtonText:
        user.status === 0 ? "Yes, Block User" : "Yes, Unblock User",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/api/v1/admin/update-user-status`,
          { userId: user._id }
        );
        setLoading(false);

        if (data.success) {
          Swal.fire("Success!", data.message, "success");
          getAllUsersData(); // refresh list
        } else {
          Swal.fire(
            "Error!",
            data.message || "Failed to update status",
            "error"
          );
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
        Swal.fire("Error!", "Something went wrong!", "error");
      }
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />

        <div className="search-add-main">
          <div className="search-main mt-0">
            <input
              type="text"
              className="search-inp"
              placeholder="Search ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
          {/* <Link to="/dashboard/admin/add-user" className="btn btn-primary me-3">
            Add New User
          </Link> */}
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>KYC Status</th>
                <th>Status</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr key={user._id}>
                    <td>{user.name || user.username || "-"}</td>
                    <td>{user.email}</td>
                    <td>{getKycBadge(user.kycstatus)}</td>
                    <td>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleStatusClick(user)}
                      >
                        {getStatusBadge(user.status)}
                      </span>
                    </td>

                    <td>
                      <button
                        onClick={() => checkStatusAndNavigate(user)}
                        className="btn btn-sm btn-outline-primary"
                      >
                        <FaEdit />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Users;
